import { UserAccountHistoryPanel } from "@/components/organisms";

export const UserAccountHistory = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <UserAccountHistoryPanel />
    </div>
  );
};
